/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.slice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getshoppingCartList, updateCar, delShowCar } from '@/api';
import utils from '@/utils/utils';
export default {
  name: 'shoppingCart',
  data: function data() {
    return {
      utils: utils,
      numberOfProducts: 1,
      checked: [],
      shoppingCartData: [],
      arrOrders: [],
      //已选商品
      stepperShow: false,
      price: 0
    };
  },
  watch: {
    checked: {
      handler: function handler(newValue, oldValue) {
        if (newValue.length < 1) {
          return this.price = 0;
        }
        this.price = newValue.reduce(function (pre, cur) {
          return pre += +cur.add_munber * +cur.price;
        }, 0).toFixed(2);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getData: function getData() {
      var _this = this;
      getshoppingCartList({}).then(function (res) {
        if (res.success) {
          _this.shoppingCartData = res.data;
        }
      });
    },
    addOrder: function addOrder(item) {
      if (this.checked.length > 0) {
        this.$router.push({
          name: 'determineOrder'
        });
        localStorage.setItem('arrOrder', JSON.stringify(this.checked));
      } else {
        this.$vux.toast.text(i18n.tc("639"));
      }
    },
    updateCars: function updateCars(item, index, num) {
      var _this2 = this;
      this.stepperShow = true;
      if (num == 1) {
        item.add_munber--;
      } else {
        item.add_munber++;
      }
      updateCar(item).then(function (res) {
        if (res.success) {
          setTimeout(function () {
            _this2.stepperShow = false;
          }, 1000);
        }
      });
    },
    delCarOrder: function delCarOrder(item) {
      var _this3 = this;
      var num = this.checked.findIndex(function (items) {
        return items.fk_t_order_cart_id == item.fk_t_order_cart_id;
      });
      this.checked = this.checked.slice(num, 1);
      delShowCar({
        fk_t_order_cart_id: item.fk_t_order_cart_id
      }).then(function (res) {
        if (res.success) {
          _this3.$vux.toast.text(i18n.tc("486"));
          _this3.getData();
        } else {
          _this3.$vux.toast.text(i18n.tc("640"));
        }
      });
    }
  },
  created: function created() {
    this.getData();
  }
};